import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/pagination/pagination.styles.ts
var pagination_styles_default = r` ${component_styles_default} :host { display: contents; margin: var(--sl-spacing-small) 0; } nav { display: inline-block; } nav ul { display: flex; list-style: none; margin: 0; padding: 0; } nav ul li fadv-button { margin: 0 var(--sl-spacing-2x-small); } .pagination__ellipsis { margin: var(--sl-spacing-x-large) var(--sl-spacing-x-small) 0 var(--sl-spacing-x-small); } .pagination--mobile { display: block; } .pagination__dropdown { flex: 1; } `;

export {
  pagination_styles_default
};
